// extracted by mini-css-extract-plugin
export default {"pollFieldsGroup":"G6Dh2nJEGJdsIUUadrnw","pollOptionRow":"Z9PW1xPiqZWRiXpD6Ag2","removeOptionButton":"qwmji1qVnpux3iMURvgA","addOptionButton":"AkOOcjFurWLVDFCQ7QdA"};